<template>
    <!--
        The wave — one continuous line behind the entire page, stroked with the
        vertical brand gradient and drawn progressively on scroll. A runtime mask
        (see libs/wave.ts) punches blurred clearance holes over every text block
        so the line reads as passing BEHIND type.
    -->
    <svg id="ob-wave" viewBox="0 0 1000 6000" preserveAspectRatio="none" aria-hidden="true">
        <defs>
            <linearGradient id="waveGrad" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0" class="stop-sky" />
                <stop offset="0.34" class="stop-blue" />
                <stop offset="0.66" class="stop-magenta" />
                <stop offset="1" class="stop-pink" />
            </linearGradient>
            <linearGradient id="waveGradCorp" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0" class="stop-sky" />
                <stop offset="0.5" class="stop-blue" />
                <stop offset="1" class="stop-blue-deep" />
            </linearGradient>
            <filter id="waveHoleBlur" x="-20%" y="-20%" width="140%" height="140%">
                <feGaussianBlur stdDeviation="7" />
            </filter>
            <mask id="waveMask" maskUnits="userSpaceOnUse" x="0" y="0" width="1000" height="6000">
                <rect x="0" y="0" width="1000" height="6000" fill="white" />
                <g id="ob-wave-holes" filter="url(#waveHoleBlur)" />
            </mask>
        </defs>
        <path
            id="ob-wave-path"
            fill="none"
            stroke="url(#waveGrad)"
            stroke-width="2.5"
            stroke-linecap="round"
            opacity=".9"
            mask="url(#waveMask)"
            d="M -60 300 C 220 200, 300 520, 560 560 C 860 606, 1010 380, 1080 520 C 1010 700, 240 700, 140 900 C 60 1064, 700 1030, 860 1180 C 980 1296, 120 1300, 60 1500 C 10 1668, 840 1600, 940 1790 C 1020 1944, 180 1900, 120 2100 C 70 2272, 880 2200, 960 2400 C 1024 2564, 200 2520, 140 2720 C 90 2892, 860 2820, 940 3020 C 1004 3184, 180 3140, 120 3340 C 70 3512, 880 3440, 960 3640 C 1024 3804, 200 3760, 140 3960 C 90 4132, 860 4060, 940 4260 C 1004 4424, 180 4380, 120 4580 C 70 4752, 880 4680, 960 4880 C 1024 5044, 240 5000, 180 5200 C 130 5372, 840 5300, 920 5500 C 984 5664, 300 5640, 240 5820"
        />
    </svg>
</template>

<style scoped>
    #ob-wave {
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
        z-index: 0;
        pointer-events: none;
    }
    @media (max-width: 767px) {
        #ob-wave-path { opacity: .4; }
    }
    .stop-sky { stop-color: var(--ob-sky); }
    .stop-blue { stop-color: var(--ob-blue); }
    .stop-blue-deep { stop-color: var(--ob-blue-deep); }
    .stop-magenta { stop-color: var(--ob-magenta); }
    .stop-pink { stop-color: var(--ob-pink); }
</style>
